<div class="flo-input d-flex align-items-center" data-test="search-box" [class.stretchy]="stretchy">
  <input
    #input
    floAnalytics
    [analyticsProperties]="searchModel?.action?.analytics"
    type="text"
    name="Search"
    events="click"
    class="search-input subhead"
    [placeholder]="searchModel?.placeholderText ?? placeholder"
    [formControl]="searchFormControl"
    data-test="search-input"
  />
  <div class="left-inner-addon mx-2">
    <span><flo-svg-icon class="grey-600" icon="icon-search" width="20px" data-test="icon-search"></flo-svg-icon></span>
  </div>
  <div class="right-inner-addon p-0" [class.d-block]="!!searchFormControl.value" (click)="clearSearch(input)" data-test="clear-search-btn">
    <span><flo-svg-icon class="grey-600 close-icon" icon="icon-times" width="20px" data-test="icon-times" (click)="clearSearch(input)"></flo-svg-icon></span>
  </div>
</div>
